import { combineReducers } from 'redux';
import tuto from './tutoReducer';
import main from './mainReducer';
import global from './globalReducer';
import profile from './profileReducer';

export default combineReducers({ global, tuto, main, profile });
